import TestimonialCards from './TestimonialCards';

export default TestimonialCards;
